<template>
  <div id="modal-call-agent" class="modal modal-call-agent" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-body text-center pt-5 pb-3 font-size-rem-13">
          <h1 class="mb-5">{{ $t('Modals/CallAgent.Incoming call') }}</h1>

          <p v-if="type === 'call' && meeting && meeting.is_appointment === false">
            {{ $t('Modals/CallAgent.A visitor wants to start a video call') }}
          </p>
          <p v-if="type === 'call' && meeting && meeting.is_appointment === true && meeting.participants.filter(participant => participant.status === 'online').length === 1">
            {{ $t('Modals/CallAgent.{PARTICIPANT} is present for the scheduled video call starting on {START_TIME}', { 'PARTICIPANT': getParticipantsList, 'START_TIME': getLocalTimeForDate(meeting.room_available_from, '').format($t('Formats.Time')) }) }}
          </p>
          <p v-if="type === 'call' && meeting && meeting.is_appointment === true && meeting.participants.filter(participant => participant.status === 'online').length > 1">
            {{ $t('Modals/CallAgent.{PARTICIPANTS} are present for the scheduled video call starting on {START_TIME}', { 'PARTICIPANTS': getParticipantsList, 'START_TIME': getLocalTimeForDate(meeting.room_available_from, '').format($t('Formats.Time')) }) }}
          </p>
          <p v-else-if="type === 'invite' && meeting">
            {{ $t('Modals/CallAgent.{NAME} would like to add you to the video call starting on {START_TIME} with {PARTICIPANTS}', { 'NAME': requestedBy, 'START_TIME': getLocalTimeForDate(meeting.room_available_from, '').format($t('Formats.Time')), 'PARTICIPANTS': getParticipantsList }) }}
          </p>
          <p v-else-if="type === 'forward' && meeting">
            {{ $t('Modals/CallAgent.{NAME} would like to hand over the video call starting on {START_TIME} with {PARTICIPANTS}', { 'NAME': requestedBy, 'START_TIME': getLocalTimeForDate(meeting.room_available_from, '').format($t('Formats.Time')), 'PARTICIPANTS': getParticipantsList }) }}
          </p>
          <p v-else-if="type === 'colleague'">
            {{ $t('Modals/CallAgent.{NAME} would like to call you', {'NAME': requestedBy} ) }}
          </p>

          <span v-if="meeting && meeting.site">{{ $t('Modals/CallAgent.Site: {SITE}', { 'SITE': meeting.site.name }) }}</span>

          <div class="row justify-content-center mt-5">
            <div class="col-12 col-sm-4 col-md-3 col-xl-2 mb-4">
              <button @click="callAccept" type="button" class="btn btn-lg btn-green text-white w-px-150 h-px-65">{{ $t('Modals/CallAgent.Accept') }}</button>
            </div>
            <div class="col-12 col-sm-4 col-md-3 col-xl-2 mb-4">
              <button @click="callHold" type="button" :disabled="callHeld" class="btn btn-lg btn-warning text-white w-px-150 h-px-65">
                <font-awesome-icon v-if="callHeld" :icon="['fas', 'pause']" class="mr-2" /> {{ $t('Modals/CallAgent.Wait') }}
              </button>
            </div>
            <div class="col-12 col-sm-4 col-md-3 col-xl-2 mb-4" v-if="typeof $route.params.token === 'undefined'">
              <button @click="callDecline" type="button" class="btn btn-lg btn-danger text-white w-px-150 h-px-65">{{ $t('Modals/CallAgent.Decline') }}</button>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getLocalTimeForDate } from '../../utils/timezoneOffset'
export default {
  name: 'CallAgent',
  data () {
    return {
      type: null,
      requestedBy: null,
      roomId: null,
      site: null,
      meeting: null,
      callHeld: false,
      ringtone: null,
      dialogOpen: false,
      shownOffer: null,
      joiningRoomId: null
    }
  },
  methods: {
    getLocalTimeForDate,
    stopRinger () {
      this.ringtone.pause()
      this.ringtone.currentTime = 0
    },
    async callAccept () {
      console.log('Call accepted')

      this.closeCallAgent()
      this.dismissOpenModals()
      this.$store.commit('setMeeting', this.meeting)
      this.joiningRoomId = this.roomId

      if (this.type === 'colleague') {
        this.$webrtc.callColleagueAccept(this.roomId)

        await this.$router.push({ name: 'meeting' })
      } else {
        // TODO: (MEDIA_SERVER) Licode-only P2P/MCU selection; delete this setP2P block with Licode.
        if (typeof this.meeting.force_non_p2p !== 'undefined' && this.meeting.force_non_p2p !== null) {
          this.$webrtc.setP2P(this.meeting.participants.length <= 3 && !this.meeting.force_non_p2p)
        } else {
          this.$webrtc.setP2P(this.meeting.participants.length <= 3)
        }
        if (this.$route.name !== 'meeting') {
          this.$root.webrtcJoin = {
            room_id: this.roomId,
            product: this.meeting.product,
            stream2way: this.meeting.stream_camera_two_way
          }

          await this.$router.push({ name: 'meeting' })
        } else {
          this.$webrtc.join(this.roomId, this.meeting.product, this.meeting.stream_camera_two_way, true)
        }
      }
    },
    callHold () {
      console.log('Call on hold')

      this.callHeld = true
      // TODO JAAP: Figure out if we really need accountId here at all
      this.$webrtc.hold(this.roomId)

      this.stopRinger()
    },
    callDecline () {
      console.log('Call declined')

      this.$webrtc.decline(this.roomId)
      this.$webrtc.setStatus('offline', true)

      this.closeCallAgent()
    },
    dismissOpenModals () {
      this.$jQuery('.modal.show').not(this.$el).modal('hide')
    },
    holdCallRequest (action, requestedBy, roomId, account) {
      const held = this.$root.heldCallRequest
      const isNewRequest = held === null || held.roomId !== roomId || held.action !== action

      console.log('Incoming call held until cam settings are saved:', action, roomId)
      this.$root.heldCallRequest = { action, requestedBy, roomId, account }

      if (isNewRequest && this.$root.bell) {
        this.$root.bell.play().catch((error) => {
          console.warn('Could not play bell due to autoplay restrictions:', error.message)
        })
      }
    },
    releaseHeldCallRequest () {
      const held = this.$root.heldCallRequest

      if (held === null) {
        return
      }

      this.$root.heldCallRequest = null
      this.callAgent(held.action, held.requestedBy, held.roomId, held.account)
    },
    async callAgent (action, requestedBy, roomId, account) {
      console.log('Incoming call:', action, requestedBy, roomId, account)

      if (this.$root.isCamSettingsOpen === true) {
        this.holdCallRequest(action, requestedBy, roomId, account)
        return false
      }

      const queuedJoin = this.$root.webrtcJoin
      const enteringRoom = this.joiningRoomId === roomId ||
        (queuedJoin !== null && queuedJoin.room_id === roomId)

      if (enteringRoom) {
        console.log('Ignoring request_join for the room we are entering:', roomId)
        return false
      }

      if (this.shownOffer !== null && this.shownOffer.roomId === roomId && this.shownOffer.action === action) {
        return false
      }

      this.shownOffer = { action, roomId }

      let betaQuery = ''
      if (this.$root.isBeta) {
        betaQuery = '&beta=true'
      }

      const meetings = await this.$axios.get(this.$axios.routes.meeting_personal + '?room_id=' + roomId + betaQuery)

      if (typeof meetings.data.result === 'undefined' || meetings.data.result === null) {
        this.shownOffer = null
        return false
      }

      const meeting = meetings.data.result[0]

      if (typeof meeting === 'undefined' || meeting === null) {
        console.error('CallAgent: no meeting returned for room_id "' + roomId + '" (action: ' + action + '). Incoming call dialog cannot be shown.', meetings.data)
        this.shownOffer = null
        return false
      }

      this.meeting = meeting
      this.type = action

      if (this.type === 'invite' || this.type === 'forward' || this.type === 'colleague') {
        this.requestedBy = requestedBy
      }

      this.roomId = roomId
      this.site = account

      this.dialogOpen = true

      if (typeof this.$route.query.auto_accept !== 'undefined' && this.$route.query.auto_accept === 'true') {
        this.callAccept()
      } else {
        this.$jQuery(this.$el).modal({ backdrop: 'static', keyboard: false }, 'show')
        if (typeof this.$route.query.disable_ringtone_incoming_call === 'undefined' || this.$route.query.disable_ringtone_incoming_call === 'false') {
          try {
            await this.ringtone.play()
          } catch (error) {
            console.warn('Could not play ringtone due to autoplay restrictions:', error.message)
            // This is expected behavior - browsers require user interaction before allowing audio
          }
        }
      }

      this.callHeld = false
    },
    async visitorStatusChanged (status, username) {
      if (this.type === 'invite' || this.type === 'forward' || this.type === 'colleague' || this.dialogOpen === false) {
        return false
      }

      console.log('Visitor status changed, change in participants array for call dialog')

      let participants

      if (status === 'online') {
        participants = this.meeting.participants.map(participant => {
          if (participant.username === username) {
            participant.status = 'online'
          }
          return participant
        })
      } else {
        participants = this.meeting.participants.map(participant => {
          if (participant.username === username) {
            participant.status = 'offline'
          }
          return participant
        })
      }

      this.meeting.participants = participants

      if (this.meeting.participants.filter(participant => participant.status === 'online').length === 0) {
        this.closeCallAgent()

        let newStatus

        if (this.$store.getters.isUINavigationEnabled) {
          if (this.$store.getters.getStatus === 'online') {
            newStatus = 'online'
          } else {
            newStatus = 'offline'
          }
        } else {
          newStatus = 'online_for_single_use_meeting'
        }

        this.$webrtc.setStatus(newStatus, true, newStatus !== 'online_for_single_use_meeting', newStatus !== 'online_for_single_use_meeting')
      }
    },
    onVisitorOnline (username) {
      this.visitorStatusChanged('online', username)
    },
    onVisitorOffline (username) {
      if (this.$root.heldCallRequest !== null && this.$root.heldCallRequest.requestedBy === username) {
        this.$root.heldCallRequest = null
      }
      this.visitorStatusChanged('offline', username)
    },
    onCancelOffer (event) {
      const cancelledRoomId = event ? event.roomId : null
      const held = this.$root.heldCallRequest

      if (held !== null && (!cancelledRoomId || held.roomId === cancelledRoomId)) {
        this.$root.heldCallRequest = null
      }

      this.closeCallAgent()
    },
    onRoomConnected () {
      this.joiningRoomId = null
    },
    onEndCall () {
      this.joiningRoomId = null
    },
    onStreamNoLongerAvailable (event) {
      console.log('Stream no longer available', event)

      if (this.dialogOpen === true) {
        this.callDecline()
      }
    },
    closeCallAgent () {
      this.stopRinger()
      this.dialogOpen = false
      this.shownOffer = null
      this.$jQuery(this.$el).modal('hide')
    }
  },
  computed: {
    getParticipantsList () {
      if (this.meeting === null) {
        return ''
      }

      let participants = this.meeting.participants

      if (typeof participants === 'undefined' || participants.length === 0) {
        return ''
      }

      participants = participants.filter(participant => participant.status === 'online').map((participant) => {
        if (participant.name === 'Bezoeker') {
          return this.$t('Modals/CallAgent.Visitor')
        } else {
          return participant.name
        }
      })

      // [0] is never the agent here, because in dialog callAgent is the status 'request_peding' for agents after onRequestJoin
      if (participants.length === 1) {
        return participants[0]
      } else {
        const lastParticipant = participants.pop()
        return participants.join().replace(/,/g, ', ') + ' ' + this.$t('Modals/CallAgent.and') + ' ' + lastParticipant
      }
    }
  },
  unmounted () {
    console.log('Destroyed CallAgent dialog')

    this.$root.heldCallRequest = null
    if (this.unwatchCamSettings) {
      this.unwatchCamSettings()
      this.unwatchCamSettings = null
    }

    this.$eventBus.$off('callAgent', this.callAgent)

    this.$webrtc.EventBus.$off('onVisitorOnline', this.onVisitorOnline)
    this.$webrtc.EventBus.$off('onVisitorOffline', this.onVisitorOffline)
    this.$webrtc.EventBus.$off('onCancelOffer', this.onCancelOffer)
    this.$webrtc.EventBus.$off('onRoomConnected', this.onRoomConnected)
    this.$webrtc.EventBus.$off('onEndCall', this.onEndCall)
    this.$webrtc.EventBus.$off('onStreamNoLongerAvailable', this.onStreamNoLongerAvailable)

    this.stopRinger()
  },
  mounted () {
    console.log('Mounted CallAgent dialog')

    this.ringtone = new Audio('/sounds/ringtone.mp3')
    this.ringtone.loop = true

    this.unwatchCamSettings = this.$watch(() => this.$root.isCamSettingsOpen, (isOpen) => {
      if (isOpen === false) {
        this.$nextTick(() => this.releaseHeldCallRequest())
      }
    })

    this.$eventBus.$on('callAgent', this.callAgent)

    this.$webrtc.EventBus.$on('onVisitorOnline', this.onVisitorOnline)
    this.$webrtc.EventBus.$on('onVisitorOffline', this.onVisitorOffline)
    this.$webrtc.EventBus.$on('onCancelOffer', this.onCancelOffer)
    this.$webrtc.EventBus.$on('onRoomConnected', this.onRoomConnected)
    this.$webrtc.EventBus.$on('onEndCall', this.onEndCall)
    this.$webrtc.EventBus.$on('onStreamNoLongerAvailable', this.onStreamNoLongerAvailable)
  }
}
</script>

<style lang="scss" scoped>
</style>
